module.exports = __webpack_public_path__ + "media/dog-profile-avatars/single-german-shepherd-e18b89ae.svg";